import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import classNames from 'classnames';
import qs from 'query-string';

import useAuthStore from 'src/hooks/auth/useAuthStore';
import config from 'src/shared/config';
import { mainPageRouteTables, routeTables } from 'src/shared/routes';
import currentUrlUtils from 'src/shared/utils/currentUrlUtils';
import { getFirstAllowedMenuPath, isAllowedMenu } from 'src/shared/utils/menuUtils';
import { RouteTable } from 'src/shared/utils/routeUtils';

import ContentBody from '../Content/ContentBody';

import './MainPage.scss';

const MainPageBody: React.FC<{
  routeTable: RouteTable;
}> = ({ routeTable }) => {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {routeTable.component ? (
        <routeTable.component routeTable={routeTable} />
      ) : (
        <ContentBody>TODO: ERROR</ContentBody>
      )}
    </>
  );
};

export const MainPageWrapper: React.FC<{
  routeTable: RouteTable;
}> = ({ routeTable }) => {
  const { authEntity } = useAuthStore();

  if (routeTable.redirect) {
    return <Navigate to={routeTable.redirect} />;
  }
  if (routeTable.auth) {
    if (authEntity === undefined) {
      console.log('is not logged in?');
      return (
        <Navigate
          to={qs.stringifyUrl({
            url: config.url('/main'),
            query: {
              redirectUrl: currentUrlUtils.getPath(),
            },
          })}
        />
      );
    }
    if (!isAllowedMenu(routeTable.adminScopes, authEntity.menus)) {
      // console.log('is not allowedMenu');
      // console.log(routeTable.adminScopes);
      // console.log(authEntity.menus);
      const firstAllowedMenuPath = getFirstAllowedMenuPath(authEntity.menus, routeTables);
      return (
        <Navigate
          to={
            firstAllowedMenuPath ? config.url(firstAllowedMenuPath) : config.url('errors/forbidden')
          }
        />
      );
      // return <Navigate to={config.url('/errors/forbidden')} />;
    }
  }

  return (
    <div className={classNames('layout-contents-root')}>
      <MainPageBody routeTable={routeTable} />
    </div>
  );
};

const MainPage: React.FC = () => {
  return (
    <Routes>
      {mainPageRouteTables.map((routeTable) => {
        // console.log(routeTable);
        return (
          <Route
            key={routeTable.fullPath}
            path={routeTable.fullPath}
            element={<MainPageWrapper routeTable={routeTable} />}
          />
        );
      })}
      {/* <Route path="*" element={<Navigate to={config.url('/errors/not-found')} />} /> */}
    </Routes>
  );
};

export default MainPage;
